export enum BiodesixTestType {
  CDTXL2 = 'cdt+xl2',
  CDT = 'cdt',
  XL2 = 'xl2',
  Nodify = 'nodify'
}
